module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat fa-xs"
  }), _vm._v(" Reload\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.downloadCogsEstimateRpt
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("download")]), _vm._v(" Export Excel")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-combobox', {
    staticClass: "pr-2",
    staticStyle: {
      "min-width": "200px",
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.countries,
      "hide-selected": "",
      "multiple": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(data.item))]), _vm._v(" \n              ")])]
      }
    }]),
    model: {
      value: (_vm.selectedFilter.country),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "country", $$v)
      },
      expression: "selectedFilter.country"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mr-2",
    staticStyle: {
      "max-width": "200px"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "All CC",
      "items": _vm.CCUsers,
      "item-text": "name",
      "item-value": "id",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.getCogsEstimation()
      }
    },
    model: {
      value: (_vm.selectedFilter.cc),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "cc", $$v)
      },
      expression: "selectedFilter.cc"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    ref: "startDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticStyle: {
            "min-width": "200px",
            "max-width": "200px"
          },
          attrs: {
            "label": "Start Month",
            "placeholdre": "Start Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDateCal),
      callback: function($$v) {
        _vm.startDateCal = $$v
      },
      expression: "startDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }, [_c('v-spacer')], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "date-divider"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('v-menu', {
    ref: "endDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mr-3",
          staticStyle: {
            "min-width": "200px",
            "max-width": "200px"
          },
          attrs: {
            "label": "End Month",
            "placeholder": "End Month",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDateCal),
      callback: function($$v) {
        _vm.endDateCal = $$v
      },
      expression: "endDateCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }, [_c('v-spacer')], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "d-flex pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    staticStyle: {
      "max-width": "250px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.getCogsEstimation
    }
  }, [_vm._v("Apply")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row mt-3",
    staticStyle: {
      "justify-content": "space-between",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Estimated COGS for " + _vm._s(_vm.currentMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.currentMthCOGS)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Estimated COGS for " + _vm._s(_vm.nextMonthLabel))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.nextMthCOGS)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm4": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Estimated COGS " + _vm._s(_vm.showFilterDate))]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "ma-0 pa-0 h3"
  }, [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(_vm.totalValues.cogsEstimate)))])]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": _vm.openMoreDetailsDialog
    }
  }, [_vm._v("\n            More Details\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _vm._l((_vm.monthsData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "campaign-cogs-section",
      attrs: {
        "id": item.name
      }
    }, [_c('v-expansion-panels', {
      staticClass: "expansion-panels mb-5",
      attrs: {
        "multiple": "",
        "accordion": ""
      },
      model: {
        value: (item.panel),
        callback: function($$v) {
          _vm.$set(item, "panel", $$v)
        },
        expression: "item.panel"
      }
    }, [_c('v-expansion-panel', {
      staticClass: "expansion-panel-main",
      attrs: {
        "expand": ""
      }
    }, [_c('v-expansion-panel-header', {
      staticClass: "expansion-panel-header"
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(_vm.formatTitle(item.month)))])]), _vm._v(" "), _c('v-expansion-panel-content', {
      staticClass: "expansion-panel-content"
    }, [_c('v-row', {
      staticClass: "no-gutters"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-row', {
      staticClass: "action-section mb-3"
    }, [_c('v-col', {
      staticClass: "action-group-section pl-0",
      attrs: {
        "cols": "12",
        "sm": "3",
        "md": "3",
        "lg": "3"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-row",
      staticStyle: {
        "gap": "3px"
      }
    }, [_c('div', [(item.selectedCOGS && item.selectedCOGS.length > 0) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "warning",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.openTotalSummaryDialog(item.selectedCOGS)
        }
      }
    }, [_vm._v("View Summary (" + _vm._s(item.selectedCOGS.length) + ")")]) : _vm._e()], 1)])]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "9",
        "md": "9",
        "lg": "9"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-right float-right"
    }, [_c('div', {
      staticClass: "mx-2",
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "label": "Search",
        "single-line": "",
        "hide-details": ""
      },
      model: {
        value: (item.filter),
        callback: function($$v) {
          _vm.$set(item, "filter", $$v)
        },
        expression: "item.filter"
      }
    })], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-data-table', {
      ref: "CreatorCogsTable",
      refInFor: true,
      staticClass: "creator-cogs-table elevation-1",
      attrs: {
        "headers": _vm.computedHeaders,
        "search": item.filter,
        "items": item.data,
        "items-per-page": 15,
        "show-select": "",
        "single-select": false
      },
      on: {
        "current-items": _vm.getFiltered
      },
      scopedSlots: _vm._u([{
        key: "item.estimatedLiveDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.estimatedLiveDate) ? _c('span', [_vm._v(_vm._s(item.estimatedLiveDate ? _vm.formatYM(item.estimatedLiveDate) : ''))]) : _vm._e()])]
        }
      }, {
        key: "item.liveDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.liveDate && item.liveDate !== 'Invalid date') ? _c('span', [_vm._v(_vm._s(item.liveDate ? _vm.formatDate(item.liveDate) : ''))]) : _vm._e()])]
        }
      }, {
        key: "item.submissionDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.submissionDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDMY(item.submissionDate) !== 'Invalid date' ? _vm.formatDMY(item.submissionDate) : ''))]) : _vm._e()])]
        }
      }, {
        key: "item.handle",
        fn: function(ref) {
          var item = ref.item;

          return [(item.handle) ? _c('div', {
            class: item.duplicate ? 'text-duplicate' : ''
          }, [_c('social-handle', {
            attrs: {
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isYoutube": item.platform === 'youtube',
              "isOthers": item.platform === 'others',
              "tiktokHandle": item.handle,
              "instagramHandle": item.handle,
              "youtubeHandle": item.handle,
              "otherHandle": item.handle
            }
          })], 1) : _vm._e()]
        }
      }, {
        key: "item.country",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.country) ? _c('span', [_vm._v(_vm._s(item.country))]) : _vm._e()])]
        }
      }, {
        key: "item.bankName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.bankName) ? _c('span', [_vm._v(_vm._s(item.bankName))]) : _vm._e()])]
        }
      }, {
        key: "item.swiftCode",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.swiftCode) ? _c('span', [_vm._v(_vm._s(item.swiftCode))]) : _vm._e()])]
        }
      }, {
        key: "item.bankAccount",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "100px!important"
            }
          }, [(item.bankAccount) ? _c('span', [_vm._v(_vm._s(item.bankAccount))]) : _vm._e()])]
        }
      }, {
        key: "item.username",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.username) ? _c('span', [_vm._v(_vm._s(item.username))]) : _vm._e()])]
        }
      }, {
        key: "item.email",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.email) ? _c('span', [_vm._v(_vm._s(item.email))]) : _vm._e()])]
        }
      }, {
        key: "item.amount",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-left' : 'text-left',
            staticStyle: {
              "min-width": "120px"
            }
          }, [(!item.pairing && (item.amount || item.amount === 0)) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]) : _vm._e(), _vm._v(" "), (item.pairing && item.GSTpercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                            " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")((item.amount - item.GSTpercent))) + "\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")((item.amount - item.GSTpercent))))])])], 1) : _vm._e(), _vm._v(" "), (item.pairing && !item.GSTpercent) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                              " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimate SGD: " + _vm._s(item.sgdAmt))]) : _vm._e()])], 1) : _vm._e()])]
        }
      }, {
        key: "item.GSTAmount",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "80px!important"
            }
          }, [(item.GSTAmount) ? _c('span', [_vm._v("$" + _vm._s(item.GSTAmount))]) : _vm._e()])]
        }
      }, {
        key: "item.GSTExcludedAmt",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.GSTExcludedAmt || item.GSTExcludedAmt === 0) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                              " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTExcludedAmt)) + "\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.GSTExcludedAmt)))]), _c('br'), _vm._v(" "), (item.sgdGstIncluded) ? _c('span', [_vm._v("Estimate SGD: " + _vm._s(item.sgdGstIncluded))]) : _vm._e()])], 1) : _vm._e()])]
        }
      }, {
        key: "item.campaignName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start',
            staticStyle: {
              "min-width": "130px!important"
            }
          }, [(item.campaignName) ? _c('span', [_vm._v(_vm._s(item.campaignName))]) : _vm._e()])]
        }
      }, {
        key: "item.clientName",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate text-start' : 'text-start'
          }, [(item.clientName) ? _c('span', [_vm._v(_vm._s(item.clientName))]) : _vm._e()])]
        }
      }, {
        key: "item.IONumber",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center"
          }, [(item.IONumber) ? _c('span', [_vm._v(_vm._s(item.IONumber))]) : _vm._e()])]
        }
      }, {
        key: "item.CC",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate' : 'text-start'
          }, [(item.CC) ? _c('span', [_vm._v(_vm._s(item.CC))]) : _vm._e()])]
        }
      }, {
        key: "item.duplicate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate' : 'text-start'
          }, [_c('div', {
            staticClass: "text-center"
          }, [_c('v-checkbox', {
            staticClass: "mt-0 pr-4",
            attrs: {
              "label": "",
              "color": "red",
              "value": false,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeDuplicate(item, item.duplicate)
              }
            },
            model: {
              value: (item.duplicate),
              callback: function($$v) {
                _vm.$set(item, "duplicate", $$v)
              },
              expression: "item.duplicate"
            }
          })], 1)])]
        }
      }, {
        key: "item.estimationType",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start"
          }, [_c('span', [_vm._v(_vm._s(item.estimationType))]), _vm._v(" "), (item.customType) ? _c('p', [_vm._v("(" + _vm._s(item.customType) + ")")]) : _vm._e()])]
        }
      }, {
        key: "item.remarks",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            class: item.duplicate ? 'text-duplicate' : 'text-start'
          }, [(item.remarks) ? _c('span', [_vm._v(_vm._s(item.remarks))]) : _vm._e()])]
        }
      }, {
        key: "item.invoices",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "120px"
            }
          }, [(item.invoices) ? _c('div', {
            staticClass: "w-100 pt-1"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  staticClass: "btn-payment-action",
                  attrs: {
                    "color": "warning",
                    "dark": "",
                    "small": "",
                    "text": ""
                  }
                }, on), [_vm._v("\n                              View\n                            ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.invoices), function(invoice, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "href": invoice.url,
                "target": "_blank"
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(invoice.name))])], 1)
          }), 1)], 1)], 1) : _vm._e()])]
        }
      }, {
        key: "item.action",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "120px"
            }
          }, [_c('div', {
            staticClass: "w-100 pt-1"
          }, [_c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "warning"
            },
            on: {
              "click": function($event) {
                return _vm.viewEditDialog(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Edit Campaign"
            }
          }, [_vm._v("edit")])], 1)], 1)])]
        }
      }], null, true),
      model: {
        value: (item.selectedCOGS),
        callback: function($$v) {
          _vm.$set(item, "selectedCOGS", $$v)
        },
        expression: "item.selectedCOGS"
      }
    })], 1)], 1)], 1)], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('create-cogs-estimate-modal', {
    attrs: {
      "editItem": _vm.editCogsEstimate,
      "value": _vm.createCogsEstimateDialog
    },
    on: {
      "created": _vm.getCogsEstimation
    },
    model: {
      value: (_vm.createCogsEstimateDialog),
      callback: function($$v) {
        _vm.createCogsEstimateDialog = $$v
      },
      expression: "createCogsEstimateDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "COGS Estimation",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.revsForMonthYear.length) ? _c('more-details-modal', {
    attrs: {
      "value": _vm.moreDetailsDialog,
      "monthYearValues": _vm.revsForMonthYear
    },
    model: {
      value: (_vm.moreDetailsDialog),
      callback: function($$v) {
        _vm.moreDetailsDialog = $$v
      },
      expression: "moreDetailsDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('total-summary-modal', {
    attrs: {
      "value": _vm.totalSummaryDialog,
      "selectedCOGS": _vm.selectedCOGS
    },
    model: {
      value: (_vm.totalSummaryDialog),
      callback: function($$v) {
        _vm.totalSummaryDialog = $$v
      },
      expression: "totalSummaryDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bacc1826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/CogsEstimate/DataTable.vue
// module id = 2279
// module chunks = 0